<template>
  <v-row no-gutters>
    <v-col cols="12" md="12" class="mt-3">
      <v-row no-gutters>
        <v-col cols="12" md="12">
          <v-row no-gutters>
            <v-col cols="5" md="2" class="pl-9">
              <v-menu
                v-model="fromMenu"
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fromDate"
                    label="From Date"
                    readonly
                    v-on="on"
                    hide-details
                    dense
                    outlined
                    filled
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fromPicker"
                  @input="fromMenu = false"
                  color="primary"
                  :max="new Date().toISOString().substr(0, 10)"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="5" md="2" class="pl-2">
              <v-menu
                v-model="toMenu"
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="toDate"
                    label="To Date"
                    readonly
                    v-on="on"
                    hide-details
                    dense
                    outlined
                    filled
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="toPicker"
                  @input="toMenu = false"
                  color="primary"
                  :max="new Date().toISOString().substr(0, 10)"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="3" class="pl-2">
              <v-autocomplete
                item-text="profileName"
                :items="riderAllList"
                v-model="riderAll"
                label="Rider"
                return-object
                hide-details
                outlined
                filled
                dense
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="1" class="pb-2 pl-2">
              <v-btn fab small depressed color="primary" @click="getSearch()">
                <v-icon>search</v-icon>
              </v-btn>
              <v-btn
              
              class="ml-4"
              fab
              small
              depressed
              color="black"
              @click="download"
            >
              <v-icon color="white">archive</v-icon>
            </v-btn>
            </v-col>
            
          </v-row>
        </v-col>
        <v-col cols="12" md="12" class="pl-3 pr-3">
          <v-simple-table
            :fixed-header="true"
            dense
            class="elevation-1 mb-2"
            height="85vh"
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center white--text primary">No.</th>
                  <th class="text-center white--text primary">
                    <v-divider vertical></v-divider>
                  </th>
                 
                  <th class="text-center white--text primary">Date</th>
                  <th class="text-center white--text primary">
                    <v-divider vertical></v-divider>
                  </th>
                  
                  <th class="text-center white--text primary">Rider</th>
                  <th class="text-center white--text primary">
                    <v-divider vertical></v-divider>
                  </th>
                 
                  <th class="text-center white--text primary">Way Count</th>
                  <th class="text-center white--text primary">
                    <v-divider vertical></v-divider>
                  </th>
                  <th class="text-center white--text primary">Opening </th>
                  <th class="text-center white--text primary">
                    <v-divider vertical></v-divider>
                  </th>
                  <th class="text-center white--text primary">Total Amount</th>
                  <th class="text-center white--text primary">
                    <v-divider vertical></v-divider>
                  </th>
                  <th class="text-center white--text primary">Fuel</th>
                  <th class="text-center white--text primary">
                    <v-divider vertical></v-divider>
                  </th>
                  <th class="text-center white--text primary">Rider Payment</th>
                  <th class="text-center white--text primary">
                    <v-divider vertical></v-divider>
                  </th>
                  <th class="text-center white--text primary">10000</th>
                  <th class="text-center white--text primary">
                    <v-divider vertical></v-divider>
                  </th>
                  <th class="text-center white--text primary">5000</th>
                  <th class="text-center white--text primary">
                    <v-divider vertical></v-divider>
                  </th>
                  <th class="text-center white--text primary">1000</th>
                  <th class="text-center white--text primary">
                    <v-divider vertical></v-divider>
                  </th>
                  <th class="text-center white--text primary">500</th>
                  <th class="text-center white--text primary">
                    <v-divider vertical></v-divider>
                  </th>
                  <th class="text-center white--text primary">200</th>
                  <th class="text-center white--text primary">
                    <v-divider vertical></v-divider>
                  </th>
                  <th class="text-center white--text primary">100</th>
                  <th class="text-center white--text primary">
                    <v-divider vertical></v-divider>
                  </th>
                  <th class="text-center white--text primary">50</th>
                  <th class="text-center white--text primary">
                    <v-divider vertical></v-divider>
                  </th>
                  <th class="text-center white--text primary">Received</th>
                  <th class="text-center white--text primary">
                    <v-divider vertical></v-divider>
                  </th>
                  <th class="text-center white--text primary">Balance</th>
                  <th class="text-center white--text primary">
                    <v-divider vertical></v-divider>
                  </th>
                  <th class="text-center white--text primary">Remark</th>
                  
                  
                </tr>
              </thead>
             <tbody>
                <tr
                  v-for="(item, index) in financeRiderPaymentDto"
                  :key="index"
                  @click="selectedOne = item"
                 :style="{
                   backgroundColor:
                     item.itemId == selectedOne.itemId
                       ? '#def3ff'
                       : 'transparent',
                 }"
                >
                  <td class="text-center" ><span v-if="item.itemId !=0">{{ index + 1 }}</span></td>
                  <td class="text-center"><v-divider vertical></v-divider></td>

                  <td class="text-center" ><span v-if="item.itemId !=0">{{ item.date| removeTime }}</span>
                   <span class="red--text" v-else>Total</span></td>
                  <td class="text-center"><v-divider vertical></v-divider></td>

                  <td class="text-left">{{ item.assignName }}</td>
                  <td class="text-center"><v-divider vertical></v-divider></td>

                  

                  <td class="text-right">{{ item.wayCount }}</td>
                  <td class="text-center"><v-divider vertical></v-divider></td>

                  
                  <td class="text-right">
                    {{ item.openingBalance | defaultPaymentFormat }}
                  </td>
                  <td class="text-center"><v-divider vertical></v-divider></td>
                  

                  <td class="text-right">
                    {{ item.totalAmt | defaultPaymentFormat }}
                  </td>
                  <td class="text-center"><v-divider vertical></v-divider></td>

                  <td class="text-right">
                    {{ item.fuelFee | defaultPaymentFormat }}
                  </td>
                  <td class="text-center"><v-divider vertical></v-divider></td>

                  <td class="text-right">
                    {{ item.riderPayment | defaultPaymentFormat }}
                  </td>
                  <td class="text-center"><v-divider vertical></v-divider></td>

                  <td class="text-center">
                    {{ item.is10000 }}
                  </td>
                  <td class="text-center"><v-divider vertical></v-divider></td>

                  <td class="text-center">
                    {{ item.is5000 }}
                  </td>
                  <td class="text-center"><v-divider vertical></v-divider></td>

                  <td class="text-center">
                    {{ item.is1000 }}
                  </td>
                  <td class="text-center"><v-divider vertical></v-divider></td>

                  <td class="text-center">
                    {{ item.is500 }}
                  </td>
                  <td class="text-center"><v-divider vertical></v-divider></td>

                  <td class="text-center">
                    {{ item.is200 }}
                  </td>
                  <td class="text-center"><v-divider vertical></v-divider></td>

                  <td class="text-center">
                    {{ item.is100 }}
                  </td>
                  <td class="text-center"><v-divider vertical></v-divider></td>

                  <td class="text-center">
                    {{ item.is50 }}
                  </td>
                  <td class="text-center"><v-divider vertical></v-divider></td>

                  

                  <td class="text-right">
                    {{ item.receivedAmt | defaultPaymentFormat }}
                  </td>
                  <td class="text-center"><v-divider vertical></v-divider></td>

                  <td class="text-right">
                    {{ item.balance | defaultPaymentFormat }}
                  </td>
                  <td class="text-center"><v-divider vertical></v-divider></td>

                  <td class="text-center">
                    {{ item.remark }}
                    <v-btn small icon color="red" @click="clickRemark(item)">
                      <v-icon>details</v-icon></v-btn
                    >
                  </td>

                  
                </tr>
                <v-divider></v-divider>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-col>
    <v-col>
      <v-dialog
      v-model="dialogRemark"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Rider Remark
        </v-card-title>

        <v-card-text>
           <v-text-field v-model="remark" label="Remark" filled outlined class="mt-2"></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="dialogRemark = false"
          >
            Cancel
          </v-btn>
          <v-btn
            class="primary"
            text
            @click="dialogSave()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-col>
  </v-row>
</template>
<script>
import financeService from "../service/FinanceService";
import accountUserService from "../service/AccountUserService";
import reportService from "../service/ReportService";
export default {
  data: () => ({
   fromMenu: false,
    toMenu: false,
    fromDate: "",
    toDate: "",
    fromPicker: new Date().toISOString().substr(0, 10),
    toPicker: new Date().toISOString().substr(0, 10),
    riderAllList: [],
    riderAll: {},
    financeRiderPaymentDto: [],
    remarkItem:{},
    dialogRemark:false,
    remark:"",
    selectedOne:{}
  }),
  props: {},
  mounted: function () {
    this.fromDate = this.formatDate(this.fromPicker);
    this.toDate = this.formatDate(this.toPicker);
    this.getUserList();
  },
  methods: {
    dialogSave:function(){
      this.dialogRemark=false;
      reportService.getFinanceByRemark(this.remarkItem.date,this.remarkItem.riderId,this.remark).then((response) => {
        this.getSearch();
      }).catch((error) => {
          this.$swal("Fail!", error.response.data.message, "error");
        });
    },
    clickRemark:function(item){
      this.remarkItem = item;
      this.dialogRemark = true;
      this.remark = item.remark;
    },
    download: function() {
      reportService.freeDailyriderpayment(this.fromDate, this.toDate, this.riderAll.userAccountId).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "dailyriderpayment.xlsx");
        document.body.appendChild(link);
        link.click();
      }).catch((error) => {
          this.$swal("Fail!", error.response.data.message, "error");
        });
    },
    formatDate(fromPicker) {
      const [year, month, day] = fromPicker.split("-");
      return `${day}-${month}-${year}`;
    },
    getUserList: function () {
      accountUserService.getAccountDeliverys().then((response) => {
        this.riderAllList.splice(0, this.riderAllList.length);
        this.riderAllList.push(
          { userAccountId: 0, profileName: "ALL" },
          ...response
        );
        this.riderAll = this.riderAllList[0];
      });
    },
    getSearch: function () {
       
      financeService
        .getDailyRiderPaymentFinance(this.fromDate, this.toDate, this.riderAll.userAccountId)
        .then((data) => {
          
          this.financeRiderPaymentDto = data;
        })
        .catch((err) => {
          this.$swal("Failed", err.response.data.message, "error");
        });
    },
  },
  
  watch: {
    fromPicker() {
      this.fromDate = this.formatDate(this.fromPicker);
    },
    toPicker() {
      this.toDate = this.formatDate(this.toPicker);
    },
  },
  components: {},
  filters: {
    removeTime: function (value) {
      if (value != undefined) {
        return value.split(" ")[0];
      }
      return "";
    },
  },
};
</script>
<style scoped>
.v-data-table td,
.v-data-table th {
  padding: 0 2px !important;
}
</style>